<script lang="ts">
export default {
  name: 'Checkbox'
}
</script>

<script setup lang="ts">

const props = defineProps<{
  label?: string,
  modelValue: boolean,
  modelId?: number | string
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'model-id', value: number | string): void;
}>();

function toggleCheck(e: Event): void {
  emit('update:modelValue', !props.modelValue);

  if (props.modelId) {
    emit('model-id', props.modelId);
  }
}
</script>

<style>
.checkbox-label > input {
  display: inline-flex;
  align-items: center;
  user-select: none;
  padding-left: 24px;
}

</style>

<template>
  <label class="checkbox-label" :class="{ 'checked': modelValue}">
    <input type="checkbox" class="custom-checkbox" :checked="modelValue" @change="toggleCheck" />
  </label>
</template>
